import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withHandlers } from 'recompose';

import FacilityPin from './FacilityPin';
import FacilityInfoWindow from './FacilityInfoWindow';

import './FacilityMarker.scss';

export const enhance = withHandlers({
	onClick: (props) => () => props.onClick(props.facility.id),
	onClose: (props) => () => props.onClick(null)
});

export function FacilityMarker(props) {
	return (
		<Fragment>
			<FacilityPin {...props} />
			{!!props.selected &&
				<FacilityInfoWindow {...props} />
			}
		</Fragment>
	);
}

FacilityMarker.propTypes = {
	selected: PropTypes.bool
};

export default enhance(FacilityMarker);
